export default __webpack_public_path__ + "static/iconography-image-f-fa3622f0751e59eff0f248863fda4a4cc39569146e5d2f5a4782a2cb875eeaa4.png";